export const SET_SETTING = 'EVENT/SET_SETTING'
export const SET_SYMPLA = 'EVENT/SET_SYMPLA'
export const SET_ZOOM = 'EVENT/SET_ZOOM'
